import { controllingSetBlocked, controllingSetLayersType } from '../../../store/controlling/actions';
import Back from '../Back';
import Content from '../Content';
import styles from '../Texture/Texture.module.scss';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

const layers = [
  {
    key: 1,
    name: '1 layer',
  },
  {
    key: 2,
    name: '3 layers',
  },
];

const Layers = ({ payload }) => {
  const selectedLayer = useSelector((s) => s.controlling.layersType);

  const dispatch = useDispatch();

  return (
    <>
      <Back title="How Many Layers" index={payload.menuIndex} />

      <Content>
        <ul className={styles.list}>
          {layers.map((layer, index) => {
            return (
              <li
                key={index}
                onClick={() => {
                  dispatch(controllingSetBlocked(true));

                  setTimeout(() => {
                    dispatch(controllingSetLayersType(layer.key));
                  }, 1000);

                  setTimeout(() => {
                    dispatch(controllingSetBlocked(false));
                  }, 2000);
                }}
              >
                <div className={cn(styles.checkbox, layer.key === selectedLayer && styles.checked)}></div>
                <div className={styles.name}>{layer.name}</div>
              </li>
            );
          })}
        </ul>
      </Content>
    </>
  );
};

export default Layers;
